import LOCAL_KEYS, { parseLocalStorageJSON } from "../../../helpers/Localstorage";
import { RequestBody } from "../../WebServiceManager/RequestBody";
import { RequestHeader } from "../../WebServiceManager/RequestHeader";

export default class QuotesRequestBody{
  quotesListRequest(method) {
    const header = new RequestHeader();
    const request = new RequestBody(
        method,
        header.applicationJson(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN))
    )
    return request;
  }


  addQuotesRequest(obj, method) {
    const header = new RequestHeader();
    const request = new RequestBody(
        method,
        header.applicationJsonWithoutToken(),
        obj
    );
    return request;
  }

  editQuotesRequest(obj, method) {
    const header = new RequestHeader();
    const request = new RequestBody(
        method,
        header.applicationJsonWithoutToken(),
        obj
    );
    return request;
  }

  quoteByIdRequest(obj,method) {
    const header = new RequestHeader();
    const request = new RequestBody(
      method, 
      header.applicationJson(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN)),
      obj
      
    );
    return request;
  }

}